import React, {useEffect} from 'react';
import {auth} from '../setup';
import FeaturedGallery from '../components/FeaturedGallery';
import {useUpdateUserMutation} from '../generated/graphql';
import makeComp from '../util/profiler';

interface GalleryProps {
  match: {
    params: {
      sortOrTag?: string;
      tag?: string;
    };
  };
}

// TODO: we should be passing the history and a match through to gallery
const GalleryPage: React.FC<GalleryProps> = makeComp(
  ({match}) => {
    const [updateUser] = useUpdateUserMutation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
      if (auth.loggedIn()) {
        (async () => {
          try {
            await updateUser({variables: {galleryVisited: true}});
          } catch (e) {
            console.error(`Failed to update user galleryVisited: ${e}`);
          }
        })();
      }
    }, [updateUser]);

    return (
      <div className="gallery-page">
        <FeaturedGallery renderSidebars match={match} />
      </div>
    );
  },
  {id: 'GalleryPage'}
);

export default GalleryPage;
